import { createFileRoute } from '@tanstack/react-router'

import ApiLogs from '@/features/Admin/ApiLogs'

export const Route = createFileRoute('/_authenticated/admin/api-logs')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ApiLogs />
}
